import script from "./businessIntro.vue?vue&type=script&setup=true&lang=js"
export * from "./businessIntro.vue?vue&type=script&setup=true&lang=js"

import "./businessIntro.vue?vue&type=style&index=0&id=e48ef4bc&lang=less&scoped=true"

import exportComponent from "/Users/liuxiong/Documents/美通官网/huanshuntong/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e48ef4bc"]])

export default __exports__